module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#video-play",
      toString: function () {
        return this.url;
      }
    }